import { useMutation, useQueryClient } from '@tanstack/react-query';

import { services } from '../../services';

export const useUpdateRecognitionRecipient = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(({ params: { orderCode }, body }) => services.orderUpdate(orderCode, body), {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['recognitionOrderDetail', variables.params.orderCode]);
    },
    ...options
  });
};
